import Vue from 'vue'
import App from './App.vue'
// import router from './routerManuaConfig'
import store from './store/store'
import router from './router/index'
import '../util/global'//全局
import permission from '../util/permission'
import './promissionRouter'//这里进行路由后台获取的模拟
import i18n from './lang' // Internationalization
import Cookies from 'js-cookie'/*引入资源请求插件*/

import VueResource from 'vue-resource'
import LicensePlate from 'vue-license-plate'
import 'vue-license-plate/lib/licensePlate.css'

import wx from 'weixin-js-sdk';

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import ElTableBar from "el-table-bar-base";
import "el-table-bar-base/lib/ElTableBar.css";
import Print from 'vue-print-nb'

import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(LicensePlate);

import pdf from 'vue-pdf'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.use(ElTableBar);
Vue.use(Print);
Vue.use(pdf);
Vue.use(permission);
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});

/*使用VueResource插件*/
Vue.use(VueResource)

//如果想使用 mock ，开启这两行即可，想看效果，看登录页的 mock登录功能
// import Mock from './mock'
// Mock.bootstrap();

import 'font-awesome/css/font-awesome.min.css'

import { Message } from 'element-ui'

Vue.config.productionTip = false

Vue.prototype.$wx = wx;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


let messageInstance = null
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
};
['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})
Vue.prototype.$message = resetMessage;
